import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ArrowGray } from "../../../assets/icons/svg/arrow-right-gray.svg";
import { ReactComponent as ArrowWhite } from "../../../assets/icons/svg/arrow-right-white.svg";
import { ReactComponent as Email } from "../../../assets/icons/svg/mail-icon.svg";
import { ReactComponent as GoogleIcon } from "../../../assets/icons/svg/google-icon.svg";
import loginVideo from "../../../assets/video/login_video.mp4";
import Logo from "../../../assets/icons/png/logo.png";
import ToastContainer, { useToast } from "../../ui/Toast_Message";

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const { toasts, showToast } = useToast();
  const navigate = useNavigate();

  const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+$/.test(email);

  // Dummy registered email list
  const registeredEmails = ["sam@openui.in", "user@acumen.com"];

  const handleLogin = () => {
    if (!isValidEmail) {
      showToast("error", "Invalid Email!", "Please enter correct email ID.");
      return;
    }

    if (registeredEmails.includes(email.trim().toLowerCase())) {
      // Navigate to OTP screen with email and flag
      navigate("/otp", {
        state: { email, fromLogin: true },
      });
    } else {
      showToast("error", "Invalid Email!", "Please enter correct email ID.");
    }
  };

  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background Video */}
      <video
        className="fixed top-0 left-0 w-screen h-screen object-cover z-0"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={loginVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="fixed top-0 left-0 w-screen h-screen bg-[#1F1F1F]/85 z-10" />

      {/* Login Card */}
      <div className="relative z-20 flex items-center justify-center w-full h-screen px-4">
        <div
          className="w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl bg-[#F3F3F3]/20 border border-white/80 rounded-2xl backdrop-blur-md px-4 sm:px-6 md:px-8 py-6 sm:py-8 flex flex-col items-center gap-5 sm:gap-6 overflow-y-auto scrollbar-none"
          style={{ minHeight: "400px", maxHeight: "90vh" }}
        >
          {/* Logo */}
          <div className="flex items-center justify-center">
            <img
              src={Logo}
              alt="Acumen Logo"
              className="h-16 sm:h-20 object-contain"
            />
          </div>

          {/* Title */}
          <div className="text-center">
            <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold text-white">
              Login
            </h1>
            <p className="text-white/70 mt-1 text-sm sm:text-base">
              Enter your credentials to access your account
            </p>
          </div>

          {/* Email Input */}
          <div className="w-full">
            <label className="block text-white mb-2 text-sm sm:text-base">
              Registered email
            </label>
            <div className="flex items-center bg-white/20 rounded-full px-3 py-2 sm:px-4 sm:py-3 border border-white/50">
              <Email className="w-5 h-5 text-white/70 mr-3" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter registered email"
                className="bg-transparent outline-none text-white placeholder-white/70 flex-grow text-sm sm:text-base"
              />
              <button
                onClick={handleLogin}
                disabled={!isValidEmail}
                className={`ml-2 p-2 rounded-full transition-colors duration-300 ${
                  isValidEmail
                    ? "bg-[#0091AF]"
                    : "bg-[#333333] cursor-not-allowed"
                }`}
              >
                {isValidEmail ? (
                  <ArrowWhite className="w-4 h-4" />
                ) : (
                  <ArrowGray className="w-4 h-4" />
                )}
              </button>
            </div>
          </div>

          {/* OR Divider */}
          <div className="flex items-center w-full">
            <hr className="flex-grow border-white/30" />
            <span className="px-3 text-white/60 text-sm">OR</span>
            <hr className="flex-grow border-white/30" />
          </div>

          {/* Google Login */}
          <button className="flex items-center justify-center gap-3 bg-white/20 text-white px-5 py-2.5 sm:px-6 sm:py-3 rounded-full hover:bg-white/30 transition text-sm sm:text-base">
            <GoogleIcon className="w-5 h-5 text-white/70" />
            Login with Google
          </button>

          {/* Footer */}
          <div className="text-white/50 text-xs sm:text-sm text-center mt-2">
            © Copyright ACUMEN 2025
          </div>
        </div>
      </div>

      {/* Toast Notification */}
      <ToastContainer toasts={toasts} />
    </div>
  );
};

export default LoginPage;
